export default "__VITE_ASSET__nVD_NNFI__"